import React from "react";
import classNames from "classnames";

const EventButton = ({
  children,
  onClick,
  disabled = false,
  loading = false,
  variant = "primary",
  size = "medium",
  fullWidth = false,
  type = "button",
}) => {
  const buttonClasses = classNames("newyear-button", {
    "newyear-button--primary": variant === "primary",
    "newyear-button--secondary": variant === "secondary",
    "newyear-button--success": variant === "success",
    "newyear-button--danger": variant === "danger",
    "newyear-button--small": size === "small",
    "newyear-button--medium": size === "medium",
    "newyear-button--large": size === "large",
    "newyear-button--fullwidth": fullWidth,
    "newyear-button--disabled": disabled,
    "newyear-button--loading": loading,
  });

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <span className="newyear-button__loader" />
      ) : (
        children
      )}
    </button>
  );
};

export default EventButton;
